namespace $.$$ {
	export class $shm_hitalama_map_widget_float_viewport_frame extends $.$shm_hitalama_map_widget_float_viewport_frame {
		
		toolbar_style_top(): string {
			return this.head_showed() ? '-40px' : '0'
		}

		@ $mol_mem
		text( next?: string ): string {
			if( next === undefined ) return this.widget().text()
			
			const frames = this.map().viewport_frames()
			const num_prev = Number( this.widget().text() )
			const num_next = Number( next )

			if( num_next < num_prev ) {
				frames.forEach( ( b: $shm_hitalama_map_widget ) => {
					const num = Number( b.text() )
					if( num >= num_next && num < num_prev )
					b.text( String( num + 1 ) )
				} )
			}
			else {
				frames.forEach( ( b: $shm_hitalama_map_widget ) => {
					const num = Number( b.text() )
					if( num > num_prev && num <= num_next )
					b.text( String( num - 1 ) )
				} )
			}

			return this.widget().text( next )
		}

		max() {
			const num = this.map().viewport_frames().length
			return num
		}

		options() {
			const options = []
			for (let i = 1; i <= this.max(); i++) {
				options.push( i.toString() )
			}
			return options
		}

		
		@ $mol_mem
		num_style_transform() {
			return `scale(${ 1 / this.zoom() })`
		}

		delete( next?: any ) {
			this.text( '9999' )
			super.delete_from_map()
		}

		ratio() {
			return this.widget().viewport_frame().ratio()
		}

		@ $mol_mem
		ratio_str( next?: string ): string {
			if( next === undefined ) {
				const ratio = this.widget().viewport_frame().ratio()
				if( ratio?.toFixed(3) == '1.778' ) return '16:9'
				return 'Произвольно'
			}
			if( next == '16:9' ) this.widget().viewport_frame().ratio( 16/9 )
			if( next == 'Произвольно' ) this.widget().viewport_frame().ratio( 0 )
			return next
		}

		@ $mol_mem
		save_last_size() {
			this.map().Last_height(null)?.val( this.height() )
			this.map().Last_width(null)?.val( this.width() )
		}

		width( next?: number ): number {
			return super.width( next )
		}

		height( next?: number ): number {
			return super.height( next )
		}
		
	}
}
